import { render, staticRenderFns } from "./OutboundShipment.vue?vue&type=template&id=66368b71&"
import script from "./OutboundShipment.vue?vue&type=script&lang=js&"
export * from "./OutboundShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports